import { Component, Input, OnInit } from '@angular/core';
import { IDeviceContract } from '@nx-fe/services';

@Component({
  selector: 'app-card-device-details',
  templateUrl: './card-device-details.component.html',
  styleUrls: ['./card-device-details.component.scss'],
})
export class CardDeviceDetailsComponent {
  @Input() device: IDeviceContract;
}
